import { useEffect, useState } from 'react';
import { getJwtToken } from 'src/authentication/cognito';
import { getApiErrorMessage } from 'src/utils/CommonUtils';

/**
 * The signed-in user's access token, read once on mount, for a request a page makes as it loads,
 * such as a useFetchForSDS call that waits for the token before it runs.
 */
export const useJwtToken = () => {
	const [jwtToken, setJwtToken] = useState('');
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		getJwtToken()
			.then(setJwtToken)
			.catch((tokenError) => setError(getApiErrorMessage(tokenError)));
	}, []);

	return { jwtToken, error };
};
